export const customerTagMap = {
  0: '',
  1: '重点客户-项目',
  2: '重点客户-非项目',
  3: '既有重点客户-项目,又有重点客户-非项目'
}